module.exports = __webpack_public_path__ + "static/img/digitization1.986a1b93.png";